import Api from './Api'

export default {
    userLogin(email, password) {
        return Api().post('/user/login', {
            email,
            password
        });
    },
    recoverPassword(email) {
        return Api().post('/user/recover', {
            email
        });
    },
    recoverPasswordCode(code, password) {
        return Api().put('user/recover', {
            code,
            password
        })
    }

}